import meter1 from "../assets/img/meter1.svg";
import meter2 from "../assets/img/meter2.svg";
import meter3 from "../assets/img/meter3.svg";
//import meter4 from "../assets/img/meter4.svg";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import arrow1 from "../assets/img/arrow1.svg";
import arrow2 from "../assets/img/arrow2.svg";
import colorSharp from "../assets/img/color-sharp.png"

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="skill" id="skills">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="skill-bx wow zoomIn">
                        <h2>Educations</h2>
                        <p>I've completed my Secondary Education or Madhyamik examination from Arambagh High School <br></br>Then I've completed my Higher Secondary Education from Arambagh High School with science Stream,...<br></br>Currently I'm pursuing B.tech CSE from JIS UNIVERSITY in 2nd year </p>
                        <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">
                            <div className="item">
                                <img src={meter1} alt="Image" />
                                <h5 onClick={() => window.open("https://www.jisuniversity.ac.in/","_blank")}>JIS UNIVERSITY <p>Computer Science & Eng...<h6>Pursuing B.Tech CSE 2nd year</h6></p></h5>
                            </div>
                            <div className="item">
                                <img src={meter2} alt="Image" />
                                <h5 onClick={() => window.open("https://www.facebook.com/Arambagh.High.School/","_blank")}>Arambagh High School <p>Completed Higher Secondary Edu.<h6>Science Stream</h6></p></h5>
                            </div>
                            <div className="item">
                                <img src={meter3} alt="Image" />
                                <h5 onClick={() => window.open("https://www.facebook.com/Arambagh.High.School/","_blank")}>Arambagh High School<p>Completed Secondary Edu.</p></h5>
                            </div>
                           
                        </Carousel>
                    </div>
                </div>
            </div>
        </div>
        <img className="background-image-left" src={colorSharp} alt="Image" />
    </section>
  )
}